import React from 'react'
import { CImage } from 'compat/coreui';
export default function Reviews() {
    return (
        <>
            <ul className="c_8 timeline">
                <li id="new_post">
                    <div className="box add">
                        <span className="title">Reviews</span>
                        <div className="textarea_wrap">
                            <tr>
                                <td>
                                    <span className="upvote">
                                        <i className="fa fa-angle-up"></i>
                                        <span>0</span>
                                        <i className="fa fa-angle-down"></i>
                                    </span>
                                </td>
                                <td><CImage  width="77%" src="/images/placeholder.svg" className="rounded-circle" /></td>
                                <td>
                                    <div>
                                        <p>Good for new producst</p>
                                        <span className="feature-text">Featured</span>
                                        <span><CImage  width="30" src="/images/11.png" /></span>
                                        <span>Posted on 03-01-21</span><span>venus</span>
                                    </div>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                        </div>
                    </div>
                </li>
            </ul>
        </>
    )
}